import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { BaseModalComponent } from "../../../models/base-modal-component";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { CommonService } from "../../../services/common/common.service";
import { RestService } from "../../../services/rest/rest.service";
import { Endpoint, HelpIndex, MessageType, UpdateStatusType } from "../../../models/enums";

@Component({
    standalone: false,
    selector: 'res-edit-shared-corpus-modal',
    templateUrl: './edit-shared-corpus-modal.component.html',
    styleUrls: ['./edit-shared-corpus-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EditSharedCorpusModalComponent extends BaseModalComponent implements OnInit {
    isBusy = false;
    isBusyMessage = 'Loading...';
    modalAutomationId = 'edit-shared-data-set-entity';
    modalTitle = "Edit Shared Data Set";
    secondaryButtonLabel = 'Cancel';
    primaryButtonLabel = 'OK';
    modalClass = 'edit-shared-data-set-modal';
    modalHelpIndex: HelpIndex;
    corpusViewHandle: string;
    corpusName: string;
    attachedProjects: any;

    selectedProject: string;

    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService
    ) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        if (this.modalData) {
            this.modalHelpIndex = HelpIndex.shared_datasets_org_manage_dlg;
            this.corpusViewHandle = this.modalData.corpusViewHandle;
            this.corpusName = this.modalData.corpusName;
            this.attachedProjects = this.modalData.attachedProjects;
            this.selectedProject = this.attachedProjects[0]?.name;
        }
    }

    ok(): void {
        this.isBusy = true;
        this.isBusyMessage = 'Update Shared Data Set...';

        this.restService.post(Endpoint.corpusManager_updateCorpusData, { newProjectName: this.selectedProject, corpusName: this.corpusName, viewHandle: this.corpusViewHandle })
            .then(response => {
                if (response) {
                    this.isBusy = false;
                    this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.CORPUS);
                    this.closeModal(true);
                }
            }, error => {
                this.isBusy = false;
            });
    }
}